import { IconTriangleFilled } from '@tabler/icons-preact';
import { type ComponentChildren, toChildArray } from 'preact';

import { classes } from '../utils/classes.ts';
import { Link } from './Link.tsx';
import { Logo } from './Logo.tsx';
import css from './PageLayout.module.css';
import { PageScrollToTop } from './PageScrollToTop.tsx';
import { PageTitle } from './PageTitle.tsx';

interface Props {
  readonly title?: null | string | readonly (string | undefined | null)[];
  readonly rootClass?: string;
  readonly mainClass?: string;
  readonly navClass?: string;
  readonly footerClass?: string;
  readonly nav?: ComponentChildren;
  readonly footer?: ComponentChildren;
  readonly children?: ComponentChildren;
}
export const PageLayout = ({ title, rootClass, mainClass, navClass, footerClass, nav, footer, children }: Props) => {
  const footerArray = toChildArray(footer);
  const navArray = toChildArray(nav).map((item) => (
    <>
      <IconTriangleFilled class={css.navArrow} />
      <span class={css.navItem}>{item}</span>
    </>
  ));

  return (
    <PageTitle title={title}>
      <div class={classes(css.root, rootClass)}>
        <header class={css.header}>
          <div class={css.content}>
            <Link href="/" variant="plain">
              <Logo class={css.logo} />
            </Link>
            <nav class={classes(css.nav, navClass)}>{navArray}</nav>
          </div>
        </header>
        <main class={css.main}>
          <div class={classes(css.content, mainClass)}>{children}</div>
        </main>
        {footerArray.length > 0 && (
          <footer class={css.footer}>
            <div class={classes(css.content, footerClass)}>{footerArray}</div>
          </footer>
        )}
        <PageScrollToTop />
      </div>
    </PageTitle>
  );
};
